import { put } from "redux-saga/effects";
import { serverRequest } from "../../actions";

export function* login3(action) {
  var payload = {
    action: "portal/login",
    strategy: action.strategy,
    props: action.props,
    source: action.source,
  };
  yield put(serverRequest(payload));
}

export default login3;
